import { useMutation } from "react-query";
import {
  VehicleLicensePlateRequestParams,
  correctVehicleLicensePlate,
} from "store/api/api";
import { handleAxiosError } from "store/util";
import { MUTATION_KEYS } from "../queryKeys";

const correctVehicleLicensePlateFn = async ({
  rowVersion,
  params,
}: {
  rowVersion: string;
  params: VehicleLicensePlateRequestParams;
}) => {
  return await correctVehicleLicensePlate(rowVersion, params);
};

export function useCorrectVehicleLicensePlate() {
  return useMutation(correctVehicleLicensePlateFn, {
    mutationKey: MUTATION_KEYS.correctVehicleLicensePlate,

    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
